import { AgeGroupCode } from '~/clients/derived-api-types'
import { StoreState } from '~/store/store'

import { AgeGroup, selectAgeGroup, selectAgeGroups, useAgeGroup, useAgeGroups } from '../'

export function useAllAgeGroups() {
    return useAgeGroups()
}

export function selectAllAgeGroups(state: StoreState): AgeGroup[] {
    return selectAgeGroups(state)
}

export function selectAgeGroupByCode(state: StoreState, ageGroupCode?: AgeGroupCode | null): AgeGroup | null {
    if (!ageGroupCode) return null

    return selectAgeGroup(state, { where: { age_group_code: ageGroupCode } }) ?? null
}

export function useAgeGroupByCode(ageGroupCode?: AgeGroupCode | null): AgeGroup | null {
    return useAgeGroup({ where: { age_group_code: ageGroupCode ?? undefined } }) ?? null
}
